<template>
  <div class="wrapper">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img v-on:click="back()" :src="icon" class="icon" />
      <p class="title">
        {{ this.$store.getters.TRANSLATIONS["reset_password"] }}
      </p>
    </div>
    <div class="content" v-if="!loading">
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["enter_new_password"] }}
      </p>
      <input
        type="password"
        v-model="password"
        placeholder
        class="password"
        autocomplete="off"
      />
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="doReset()" class="button">
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      password: "",
      doReset: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(`${process.env.SERVER_URL}/6CA4E5AD7CDA4D369FEFEF1B4F44B3C0`, {
            password: this.password,
            passwordCode: `${this.$store.getters.RESET_PASS_CODE}`
          })
          .then((response) => {
            let error;
            if (this.password.length < 6) {
              error = this.$store.getters.TRANSLATIONS["password_length"];
            }
            if (error) {
              this.$modal.show("dialog", {
                text: error,
                buttons: [
                  {
                    title: "OK"
                  }
                ]
              });
            } else {
              if (response && response.status == 200) {
                this.$modal.show("dialog", {
                  text: this.$store.getters.TRANSLATIONS[
                    "password_was_changed"
                  ],
                  buttons: [
                    {
                      title: "OK",
                      handler: () => {
                        this.$router.push("/login");
                      }
                    }
                  ]
                });
              } else {
                let text =
                  this.$store.getters.TRANSLATIONS["something_went_wrong"];
                this.$modal.show("dialog", {
                  text,
                  buttons: [
                    {
                      title: "OK",
                      handler: () => {
                        this.$router.push("/login");
                      }
                    }
                  ]
                });
              }
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              text = error.response.data.message;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$router.push("/login");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      back: () => {
        this.$router.push("/login");
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/NewPassword.vue